module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "login"
  }, [(!_vm.showSuccess) ? _c('section', {
    staticClass: "login__modal"
  }, [_c('h2', {
    staticClass: "login__title"
  }, [_vm._v(_vm._s(_vm.L.localize('Account_Breadcrumb_Register')))]), _vm._v(" "), (!_vm.showSuccess) ? _c('form', {
    staticClass: "form js-form",
    attrs: {
      "data-form": "login"
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.send.apply(null, arguments)
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.send.apply(null, arguments)
      }
    }
  }, [(_vm.error) ? _c('span', {
    staticClass: "form__validation"
  }, [_vm._v("\n        " + _vm._s(_vm.error) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('TextBox', {
    attrs: {
      "label": "Label_EmailAddress",
      "validate": _vm.$v.model,
      "modelPath": "email",
      "acc": "email",
      "type": "email"
    },
    on: {
      "input": _vm.$v.model.email.$touch
    },
    model: {
      value: (_vm.model.email),
      callback: function($$v) {
        _vm.$set(_vm.model, "email", $$v)
      },
      expression: "model.email"
    }
  }), _vm._v(" "), _c('TextBox', {
    attrs: {
      "label": "Label_Password",
      "validate": _vm.$v.model,
      "modelPath": "password",
      "acc": "password",
      "type": "password"
    },
    on: {
      "input": _vm.$v.model.password.$touch
    },
    model: {
      value: (_vm.model.password),
      callback: function($$v) {
        _vm.$set(_vm.model, "password", $$v)
      },
      expression: "model.password"
    }
  }), _vm._v(" "), _c('TextBox', {
    attrs: {
      "label": "Label_ConfirmPassword",
      "validate": _vm.$v.model,
      "modelPath": "confirmPassword",
      "acc": "confirmPassword",
      "type": "password"
    },
    on: {
      "input": _vm.$v.model.confirmPassword.$touch
    },
    model: {
      value: (_vm.model.confirmPassword),
      callback: function($$v) {
        _vm.$set(_vm.model, "confirmPassword", $$v)
      },
      expression: "model.confirmPassword"
    }
  }), _vm._v(" "), _c('Btn', {
    attrs: {
      "isLoading": _vm.loading,
      "label": "Account_Breadcrumb_Register"
    },
    on: {
      "click": _vm.send
    }
  })], 1) : _vm._e()]) : _c('div', {
    staticClass: "login__modal"
  }, [_c('span', {
    staticClass: "form__success"
  }, [_vm._v("\n        " + _vm._s(_vm.L.localize("Account_ResetPassword_Text")) + "\n      ")]), _vm._v(" "), _c('Btn', {
    attrs: {
      "label": "Login_LoginButton"
    },
    on: {
      "click": _vm.gotoLogin
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d7df64b0!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/views/account/Register.vue
// module id = 761
// module chunks = 1